import React, { useState, useEffect, useCallback } from "react";
import BulkActionsForm from "./BulkActionsForm";
import LanguageStringResolver from "../fields/language/LanguageStringResolver";
import { connect } from "react-redux";
import BULK_ACTION_CONTROLLER from "../../controllers/bulkAction";
import Logger, { LOG_LEVELS, ALL_MESSAGES } from "../../utils/logger";
import ApplicationMessages from "../inAppMessages/ApplicationMessages";
import BulkActionStatusData from "./BulkActionStatusData";
import BulkTransactionErrorModal from "./BulkTransactionErrorModal";

const PAGE_NAME = 'BULK_ACTION_PAGE';
const log = new Logger(PAGE_NAME, LOG_LEVELS.DEBUG);

export const BulkActions = (props) => {

    const [values, setValues] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [selectedOperation, setSelectedOperation] = useState(null);
    const [errorDetails, setErrorDetails] = useState({});
    const [showErrorDetails, setShowErrorDetails] = useState(false);

    const handleFormSubmitted = (action, selections) => {
        setValues({
            ...selections,
            action: action,
            tenantId: props.customerId
        });
    }

    const onShowDetailsClickHandler = useCallback(
        () => {
            setShowErrorDetails(true);
        },
        [setShowErrorDetails]
    );

    const closeModal = () => {
        setShowErrorDetails(false);
    };

    useEffect(() => {
        if (values && Object.keys(values).length > 0) {
            log.clearAllDictionaryErrors();
            props.onBulkActions(
                values,
                () => {
                    log.setDictionaryMessage(ALL_MESSAGES.BULK_ACTION_INITIATED);
                },
                (error) => {
                    if (error.status === 400) {
                        if (error.entities && error.entities.length > 0) {
                            log.setDictionaryMessage(ALL_MESSAGES.BULK_ACTION_INVALID_ENTITIES_RETURNED);
                            setErrorDetails({
                                entities: error.entities.map(id => ({
                                    status: 'Failed',
                                    entityId: id,
                                    reason: error.message
                                }))
                            });
                        }
                        else if (error.message) {
                            log.setDictionaryMessage(ALL_MESSAGES.BULK_ACTION_API_ERROR, error.message);
                        }
                        else {
                            log.setDictionaryMessage(ALL_MESSAGES.BULK_ACTION_INVALID_REQUEST);
                        }
                    } else {
                        log.setDictionaryMessage(ALL_MESSAGES.BULK_ACTION_GENERIC_ERROR);
                    }
                }
            );
        }
    }, [values]);

    return (
        <s-container class="mb50">
            <h1 className="mt20"><LanguageStringResolver string='TitleBulkActions' /></h1>
            <BulkActionStatusData
                showModal={showModal}
                setShowModal={setShowModal}
                selectedOperation={selectedOperation}
                setSelectedOperation={setSelectedOperation}
                tenantId={props.customerId}
                userId={props.userName}
            />
            <ApplicationMessages
                scopes={[PAGE_NAME]}
                messageIds={[ALL_MESSAGES.BULK_ACTION_INVALID_REQUEST, ALL_MESSAGES.BULK_ACTION_GENERIC_ERROR, ALL_MESSAGES.BULK_ACTION_API_ERROR]}
                messageType="applicationError"
            />
            <ApplicationMessages
                scopes={[PAGE_NAME]}
                messageIds={[ALL_MESSAGES.BULK_ACTION_INVALID_ENTITIES_RETURNED]}
                messageType="applicationError">
                <span>
                    <a onClick={() => onShowDetailsClickHandler()}>
                        <LanguageStringResolver string="BulkAction_CompleteError"/>
                    </a>
                </span>
            </ApplicationMessages>
            <ApplicationMessages
                scopes={[PAGE_NAME]}
                messageIds={[ALL_MESSAGES.BULK_ACTION_INITIATED]}
                messageType="applicationInfo"
            />
            <BulkActionsForm
                reporterName={props.userName}
                onSubmit={handleFormSubmitted}
            />
            {<BulkTransactionErrorModal operation={errorDetails} showModal={showErrorDetails} onClose={closeModal} />}
        </s-container>
    )
}

const mapStateToProps = (state) => {
    return {
        userName: state.authentication?.data?.userName || "Unknown",
        customerId: state.authentication && state.authentication?.data && state.authentication?.data?.customerId || []
    };
}

const mapDispatchersToProps = (dispatch) => {
    return {
        onBulkActions: (values, successCallback, failureCallback) => {
            dispatch(BULK_ACTION_CONTROLLER.doBulkAction(values, successCallback, failureCallback));
        }
    }
}

export default connect(mapStateToProps, mapDispatchersToProps)(BulkActions);